module.exports = __webpack_public_path__ + "static/media/home_icon.551c8668.svg";